export class ReportGroup {
  reportGroup: string;
  reportGroupID: number;
  reports: Report[];
}

export class Report {
  reportName: string;
  reportID: number;
  isFavorite: boolean;
  favTogglePending: boolean;
  reportServerURL: string;
  reportURL: string;
  reportDescription: string;
  userID: number;
  reportGroup?: string;
  reportGroupID?: number;
  biReportID?: string;
  biGroupID?: string;
  biDatasetID?: string;
}
